<template>
  <div class="expansion-pressure-wrapper">
    <detail-section title="压力测试" :show-border="true">
      <div class="pressure-content">
        <div class="chart-info-box">
          <div id="chartContainer" class="pressure-chart"></div>
          <div class="pressure-info">
            <div class="params-box">
              <div class="params-tit">测试参数</div>
              <div class="params-item">
                <span class="params-label">节点数：</span>
                <span>{{ 16 || $constants.EMPTY }}</span>
              </div>
              <div class="params-item">
                <span class="params-label">网络带宽：</span>
                <span v-if="bandwidth">{{ bandwidth || $constants.EMPTY }} Mbps</span>
              </div>
              <div class="params-item">
                <span class="params-label">网络延时：</span>
                <span v-if="ms">{{ ms || $constants.EMPTY }} ms</span>
              </div>
            </div>
            <div class="btns-box">
              <el-button type="primary" @click="startTest()">
                开始压力测试
              </el-button>
            </div>
          </div>
        </div>
        <el-divider></el-divider>
        <div class="result-box">
          <div class="result-tit">
            结果信息显示窗口
          </div>
          <div ref="list" class="result-content">
            <empty v-if="dataText && dataText.length == 0" description="暂无数据"></empty>
            <div v-for="(item, dIndex) in dataText" :key="dIndex" class="result-item">
              •&emsp;{{ item.time }}&emsp;交易数量：{{ item.num }}
            </div>
          </div>
        </div>
      </div>
    </detail-section>
  </div>
</template>

<script>
let echarts = require('echarts') 
import themeVarsDefine from '@/mixins/themeVarsDefine';
import adaptation from '@/mixins/adaptation';

export default {
  name: 'PressureTest',
  mixins: [themeVarsDefine, adaptation],
  themeVarsDefine: {
    dark: {
      xAxisAxisLabelColor: '#78B3CD',
      yAxisAxisLabelColor: '#78B3CD',
      yAxisSplitLineColor: '#33406D',
      seriesLineColor: '#1CBCFF',
      seriesAreaStartColor: '#5AA4CB',
      seriesAreaEndColor: 'rgba(48, 111, 255, 0.00)',
      tooltipBorderColor: '#303C65',
      tooltipBackgroundColor: '#112245',
      tooltipTextColor: '#FFF',
      tooltipAxisLineColor: '#fff',
      tooltipSymbolColor: '#1CBCFF'
    },
    default: {
      xAxisAxisLabelColor: '#5A6973',
      yAxisAxisLabelColor: '#5A6973',
      yAxisSplitLineColor: '#F9F9F9',
      seriesLineColor: '#1CBCFF',
      seriesAreaStartColor: '#45C2FF',
      seriesAreaEndColor: 'rgba(255, 255, 255, 0.00)',
      tooltipBorderColor: '#F9F9F9',
      tooltipBackgroundColor: '#fff',
      tooltipTextColor: '#122836',
      tooltipAxisLineColor: '#122836',
      tooltipSymbolColor: '#1CBCFF'
    }
  },
  adaptationVarsDefine: {
    axisLabelFontSize: 10,
    yAxisSplitLineWidth: 1,
    seriesLineWidth: 1,
    tooltipBorderWidth: 1,
    tooltipPadding: 16,
    tooltipFontSize: 12,
    tooltipBorderRadius: 2,
    tooltipAxisLineWidth: 1,
    seriesSymbolSize: 6
  },
  data() {
    return {
      index: 0,
      bandwidth: null,
      ms: null,
      chart: null,
      intervalId: null,
      dataObj: [],
      dataText: [],
      formattedTimeText: '',
      xAxisLabel: {
        type: 'category',
        data: []
      },
      option: {
        tooltip: {
          show: true,
          trigger: 'axis',
          borderColor: '#303C65',
          borderWidth: 1,
          backgroundColor: '#112245',
          padding: 16,
          formatter: function (item) {
            let data = item[0].value
            let time = item[0].axisValue
            return time + '</br>' + '交易量：' + `<span style="color:#6DD4FF;">${data}</span>`
          },
          textStyle: {
            color: '#fff',
            fontWeight: 400,
            fontSize: 12,
            fontStyle: 'normal',
            lineHeight: 'normal'
          },
          extraCssText: 'border-radius: 2px;',
          axisPointer: {
            lineStyle: {
              color: '#FFF',
              width: 1
            }
          }
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            show: true,
            textStyle: {
              color: '#78B3CD',
              fontSize: 10
            }
          },
          axisLine: {
            lineStyle: {
              color: ''
            }
          },
          interval: 0,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          boundaryGap: ['4.5%', '2.7%']
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              color: '#78B3CD',
              fontSize: 10
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#33406D',
              width: 1,
            }
          },
          axisLine: {
            lineStyle: {
              color: ''
            }
          },
          axisTick: {
            show: false
          },
          splitNumber: 5
        },
        series: [
          {
            data: [],
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            showSymbol: true,
            itemStyle: {
              color: 'transparent',
              borderColor: '#fff'
            },
            lineStyle: {
              width: 1,
              color: '#1CBCFF'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#5AA4CB'
                },
                {
                  offset: 1,
                  color: 'rgba(48, 111, 255, 0.00)'
                }
              ])
            }
          }
        ],
        grid: {
          left: '5.6%',
          top: '20.3%',
          right: '1.79%',
          bottom: '18.6%',
        },
        backgroundColor: ''
      }
    }
  },
  watch: {
    themeVars: function (val) {
      this.chart.setOption({
        tooltip: {
          borderColor: val.tooltipBorderColor,
          backgroundColor: val.tooltipBackgroundColor,
          textStyle: {
            color: val.tooltipTextColor,
          },
          axisPointer: {
            lineStyle: {
              color: val.tooltipAxisLineColor
            }
          }
        },
        xAxis: {
          axisLabel: {
            textStyle: {
              color: val.xAxisAxisLabelColor
            }
          }
        },
        yAxis: {
          axisLabel: {
            textStyle: {
              color: val.yAxisAxisLabelColor
            }
          },
          splitLine: {
            lineStyle: {
              color: val.yAxisSplitLineColor
            }
          }
        },
        series: [{
          itemStyle: {
            borderColor: val.tooltipSymbolColor
          },
          lineStyle: {
            color: val.seriesLineColor
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: val.seriesAreaStartColor
              },
              {
                offset: 1,
                color: val.seriesAreaEndColor
              }
            ])
          }
        }]
      });
    },
    adaptationVars: function (val) {
      this.chart.setOption({
        tooltip: {
          borderWidth: val.tooltipBorderWidth,
          padding: val.tooltipPadding,
          textStyle: {
            fontSize: val.tooltipFontSize,
          },
          extraCssText: `border-radius: ${val.tooltipBorderRadius}px;`,
          axisPointer: {
            lineStyle: {
              width: val.tooltipAxisLineWidth
            }
          }
        },
        xAxis: {
          axisLabel: {
            textStyle: {
              fontSize: val.axisLabelFontSize
            }
          }
        },
        yAxis: {
          splitLine: {
            lineStyle: {
              width: val.yAxisSplitLineWidth
            }
          },
          axisLabel: {
            textStyle: {
              fontSize: val.axisLabelFontSize
            }
          }
        },
        series: [{
          symbolSize: val.seriesSymbolSize,
          lineStyle: {
            width: val.seriesLineWidth,
          }
        }]
      });
      this.resize();
    }
  },
  mounted() {
    this.initChart()
    this.getCurrentTime()
    window.addEventListener('resize', this.resize, false)
  },
  destroyed() {
    clearInterval(this.intervalId)
    this.index = 0
    this.dataObj = []
    this.dataText = []
  },
  methods: {
    initChart() {
      let container = document.getElementById('chartContainer')
      let chartbox = echarts.init(container)
      chartbox.setOption(this.option)
      this.chart = chartbox
    },
    resize() {
      this.chart.resize()
    },
    startTest() {
      let _this = this
      clearInterval(this.intervalId)
      this.index = 0
      this.dataObj = []
      this.dataText = []
      this.xAxisLabel.data = []
      _this.handlePressuretTest() // 刚进入页面时调用一次
      if (_this.index < 60) {
        this.intervalId = setInterval(() => {
          _this.index++
          _this.handlePressuretTest() // 每隔一秒调用一次
          if (_this.index === 59) {
            clearInterval(_this.intervalId) // 执行了59次后停止定时器
          }
        }, 1000)
      }
    },
    handlePressuretTest() {
      this.$apis.expansionDemo
        .pressuretTest()
        .then(res => {
          if (res) {
            this.dataObj.push(res.data.num)
            res.data.time = this.getCurrentTime()
            this.dataText.push(res.data)
            this.xAxisLabel.data.push(this.formatTimeFromTimestamp(new Date().getTime()))
            this.bandwidth = (Math.random() * (12 - 8) + 8).toFixed(2).padEnd(4, '0')

            this.ms = Math.floor(Math.random() * (200 - 80 + 1)) + 80
            let opt = [
              {
                data: this.dataObj,
                type: 'line',
                smooth: true
              }
            ]
            this.chart.setOption({
              series: opt,
              xAxis: this.xAxisLabel
            })

            this.scrollToEnd()
            // this.$message.success('获取用户关联通道成功')
          }
          this.disabled = false
        })
        .catch(err => {
          this.disabled = false
        })
    },
    formatTimeFromTimestamp(timestamp) {
      const date = new Date(timestamp)
      const formattedTime = date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      return formattedTime
    },
    getCurrentTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      const formattedTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      this.formattedTimeText = formattedTime
      return formattedTime
    },
    scrollToEnd() {
      let self = this
      this.$nextTick(() => {
        if(self.$refs.list) {
          let scrollTop = self.$refs.list.scrollHeight - self.$refs.list.clientHeight
          self.$refs.list.scrollTo({
            top: scrollTop,
            left: 0,
            behavior: 'smooth'
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme('expansion-pressure-wrapper', (
  --expansion-pressure-wrapper-pressure-info-background-color: #303c65,
  --expansion-pressure-wrapper-params-color: #fff,
  --expansion-pressure-wrapper-result-box-color: #fff,
), (
  --expansion-pressure-wrapper-pressure-info-background-color: #F6F7F9,
  --expansion-pressure-wrapper-params-color: #192227,
  --expansion-pressure-wrapper-result-box-color: #192227
));
.expansion-pressure-wrapper {
  @include adaptation(
    (
      --expansion-pressure-wrapper-detail-section-padding: 4px 16px 12px,
      --expansion-pressure-wrapper-detail-section-content-padding: 4px 0,
      --expansion-pressure-wrapper-pressure-chart-height: 236px,
      --expansion-pressure-wrapper-pressure-info-width: 327px,
      --expansion-pressure-wrapper-pressure-info-height: 236px,
      --expansion-pressure-wrapper-pressure-info-padding: 16px 24px,
      --expansion-pressure-wrapper-params-tit-font-size: 14px,
      --expansion-pressure-wrapper-params-tit-margin-bottom: 24px,
      --expansion-pressure-wrapper-params-tit-line-height: 20px,
      --expansion-pressure-wrapper-params-item-font-size: 12px,
      --expansion-pressure-wrapper-params-item-line-height: 17px,
      --expansion-pressure-wrapper-params-item-margin-bottom: 16px,
      --expansion-pressure-wrapper-btns-box-margin-top: 33px,
      --expansion-pressure-wrapper-result-box-padding: 16px 18px,
      --expansion-pressure-wrapper-result-box-unavailable-height: 511px,
      --expansion-pressure-wrapper-result-tit-font-size: 14px,
      --expansion-pressure-wrapper-result-tit-line-height: 20px,
      --expansion-pressure-wrapper-result-tit-margin-bottom: 16px,
      --expansion-pressure-wrapper-result-content-unavailable-height: 68px,
      --expansion-pressure-wrapper-result-content-padding: 8px 0 0,
      --expansion-pressure-wrapper-result-content-empty-unavailable-height: 8px,
      --expansion-pressure-wrapper-result-content-item-font-size: 12px,
      --expansion-pressure-wrapper-result-content-item-line-height: 17px,
      --expansion-pressure-wrapper-result-content-item-margin-bottom: 16px,
    )
  );

  --expansion-pressure-wrapper-result-box-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--expansion-pressure-wrapper-result-box-unavailable-height)
  );
  --expansion-pressure-wrapper-result-content-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--expansion-pressure-wrapper-result-box-unavailable-height) -
      var(--expansion-pressure-wrapper-result-content-unavailable-height)
  );
  --expansion-pressure-wrapper-result-content-empty-height: calc(
    var(--expansion-pressure-wrapper-result-content-height) -
      var(--expansion-pressure-wrapper-result-content-empty-unavailable-height)
  );
  .cbaas-detail-section /deep/ {
    padding: var(--expansion-pressure-wrapper-detail-section-padding);
    .content {
      padding: var(--expansion-pressure-wrapper-detail-section-content-padding);
    }
  }

  .pressure-content {
    display: flex;
    flex-direction: column;

    .chart-info-box {
      display: flex;

      .pressure-chart {
        flex-grow: 1;
        height: var(--expansion-pressure-wrapper-pressure-chart-height);
      }

      .pressure-info {
        width: var(--expansion-pressure-wrapper-pressure-info-width);
        height: var(--expansion-pressure-wrapper-pressure-info-height);
        background-color: var(--expansion-pressure-wrapper-pressure-info-background-color);
        padding: var(--expansion-pressure-wrapper-pressure-info-padding);

        .params-box {
          color: var(--expansion-pressure-wrapper-params-color);
          .params-tit {
            font-size: var(--expansion-pressure-wrapper-params-tit-font-size);
            font-weight: 500;
            margin-bottom: var(--expansion-pressure-wrapper-params-tit-margin-bottom);
            line-height: var(--expansion-pressure-wrapper-params-tit-line-height);
            height: var(--expansion-pressure-wrapper-params-tit-line-height);
          }

          .params-item {
            font-size: var(--expansion-pressure-wrapper-params-item-font-size);
            line-height: var(--expansion-pressure-wrapper-params-item-line-height);
            height: var(--expansion-pressure-wrapper-params-item-line-height);
            margin-bottom: var(--expansion-pressure-wrapper-params-item-margin-bottom);
          }
        }

        .btns-box {
          display: flex;
          justify-content: center;
          margin-top: var(--expansion-pressure-wrapper-btns-box-margin-top);
        }
      }
    }

    .el-divider {
      margin: 0;
    }

    .result-box {
      color: var(--expansion-pressure-wrapper-result-box-color);
      padding: var(--expansion-pressure-wrapper-result-box-padding);
      height: var(--expansion-pressure-wrapper-result-box-height);

      .result-tit {
        font-size: var(--expansion-pressure-wrapper-result-tit-font-size);
        font-weight: 500;
        line-height: var(--expansion-pressure-wrapper-result-tit-line-height);
        height: var(--expansion-pressure-wrapper-result-tit-line-height);
        margin-bottom: var(--expansion-pressure-wrapper-result-tit-margin-bottom);
      }

      .result-content {
        overflow-y: auto;
        padding: var(--expansion-pressure-wrapper-result-content-padding);
        height: var(--expansion-pressure-wrapper-result-content-height);

        .el-empty {
          min-height: var(--expansion-pressure-wrapper-result-content-empty-height);
        }
        
        .result-item {
          font-size: var(--expansion-pressure-wrapper-result-content-item-font-size);
          line-height: var(--expansion-pressure-wrapper-result-content-item-line-height);
          height: var(--expansion-pressure-wrapper-result-content-item-line-height);
          margin-bottom: var(--expansion-pressure-wrapper-result-content-item-margin-bottom);

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
